import React, { Component } from "react";

/*
This component returns a form to select the currency rate to convert 
the USD amount entered by the user and also displays the total.
The component also uses props from the Converter component.*/
export class Currencies extends Component {
  render() {
    return (
      <form action="" className="form-inline mb-4">
        {/* display total */}
        <div className="input-group mb-3">
          <span className="input-group-text" id="inputGroup-sizing-default">
            TOTAL
          </span>
          <input
            type="text"
            className="form-control"
            aria-label="Sizing example input"
            aria-describedby="inputGroup-sizing-default"
            disabled={true}
            // value uses a ternary to display amount or Calculating while fetching the api and calling the calculate() function.
            value={
              this.props.result === null ? "Calculating..." : this.props.result
            }
          />
        </div>

        {/* select options */}
        <div className="input-group mb-3">
          <label className="input-group-text" htmlFor="inputGroupSelect01">
            CURRENCY
          </label>
          <select
            className="form-select pointer"
            id="inputGroupSelect01"
            name="convertTo"
            // convertTo value passed through props
            value={this.props.convertTo}
            // handleSelect function passed through props form the Converter component.
            onChange={this.props.handleSelect}
          >
            {/* mapping currencies array passed through props, to display as options for the select element. */}
            {this.props.currencies.map((currency) => (
              <option key={currency} vale={currency}>
                {currency}
              </option>
            ))}
          </select>
        </div>
      </form>
    );
  }
}

export default Currencies;
